import { Component, OnInit } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-reject-action-modal',
    templateUrl: './reject-action-modal.component.html',
    styleUrls: ['./reject-action-modal.component.scss'],
    standalone: false
})
export class RejectActionModalComponent implements OnInit {
  //@ts-ignore
  reason: string;

  ngOnInit(): void {
  }

  constructor(public modal: NzModalRef<RejectActionModalComponent>, private modalService: NzModalService) {

  }

  cancel() {
    this.modal.close();
  }

  onConfirm() {
    this.modalService.confirm({
      nzTitle: 'Confirm',
      nzContent: 'Are you sure you want to reject this application?',
      nzOkText: 'OK',
      nzCancelText: 'Cancel',
      nzOnOk: () => this.confirm()
    });
  }

  confirm() {
    this.modal.close(this.reason);
  }
}
